import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {Translate} from 'views/module';
import {AccountBox} from 'views/icons';

import QuestionTypes from './question_types';

const BiographyQuestion = (props) => {
  const mode = props.mode;

  const bioQuestion = props.bioQuestion;
  const updateQuestionData = props.updateQuestionData;
  const caregiverBackend = props.caregiverBackend;
  const subQuestion = props.subQuestion?? false;
  const getSignedFileUrl = caregiverBackend.bioQuestions.getSignedFileUrl;
  const editPhotoUrl = caregiverBackend.detail.editPhotoUrl;

  const untitledFieldTypes = ['checkbox', 'array'];

  const QuestionType = QuestionTypes[bioQuestion.fieldType];

  const hasTitle = !untitledFieldTypes.includes(bioQuestion.fieldType);

  const makeProfilePhotoHandler = (file) => {
    editPhotoUrl(file.src);
  };

  return (
    <Stack
      sx={{
        width: '100%',
        alignItems: subQuestion ? 'center' : 'normal',
      }}
      direction={subQuestion ? 'row' : 'column'}
      gap={subQuestion ? 1 : undefined}
    >
      {
        mode === 'VIEW' && hasTitle && <Typography
          variant="subtitle1"
          fontWeight={subQuestion ? 'normal' : 'bold'}
        >
          <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestion.bioQuestionId}`} />:
        </Typography>
      }
      <QuestionType.Content
        bioQuestion={bioQuestion}
        updateQuestionData={updateQuestionData}
        mode={mode}
        setViewMode={()=>undefined}
        getSignedFileUrl={getSignedFileUrl}
        extraFileMenuItems={[
          mode === 'VIEW' && {
            Icon: AccountBox,
            text: 'Make profile photo',
            handler: makeProfilePhotoHandler,
            condition: (file) => file.type.match(/^image\/.*$/),
          },
        ]}
      />
    </Stack>
  );
};

BiographyQuestion.propTypes = {
  bioQuestion: PropTypes.any.isRequired,
  updateQuestionData: PropTypes.func.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  subQuestion: PropTypes.bool,
};

export default BiographyQuestion;
